module.exports = __webpack_public_path__ + "dcd5603e769103daf42c7ed6cb4ae237.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fovPreview/white.jpg
// module id = 1656
// module chunks = 5